import { render } from "./EditValidationQueuePage.vue?vue&type=template&id=476e0c92&ts=true"
import script from "./EditValidationQueuePage.vue?vue&type=script&lang=ts"
export * from "./EditValidationQueuePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__